<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <!-- 弹窗, 新增 / 修改 -->
    <rewardUpdate v-show="addOrUpdateVisible" ref="rewardUpdate"></rewardUpdate>
  </div>
</template>

<script>
    import tablePage from '@/views/mis/customerRelation/table.vue'
    import FORM from '../components/page/form.vue'
    import rewardUpdate from '../rebate/rewardUpdate.vue'
    import DataUtil from '@/views/mis/util/data'
    import download from '@/utils/download'
    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'

    let proposalType = {0: "新增", 1: "修改"};
    let proposalStatus = {0: "未审核", 1: "已审核", 2: "已取消"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            rewardUpdate
        },
        methods: {
            checkbox(row) {
                this.ids = row.map(key => key.id).join(",");
                this.proposals = row.map(key => key.proposalStatus).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "details") {
                    this.addOrUpdateHandle(row,true);
                }
            },
            // 新增 / 修改
            addOrUpdateHandle(row,type) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.rewardUpdate.detail = type;
                    this.$refs.rewardUpdate.dataForm.activeType = 0;
                    this.$refs.rewardUpdate.init(row)
                })
            },
            judge() {
                if (!this.proposals && this.proposals.length <= 0) {
                    this.$message({
                        message: window.$t('mis.accountReward.choiceOne'),
                        type: 'warning'
                    });
                    return false;
                }
                if ((this.proposals.indexOf("1") != -1) || this.proposals.indexOf("2") != -1) {
                    this.$message({
                        message: window.$t('mis.accountReward.notSatisfiable'),
                        type: 'warning'
                    });
                    return false;
                }
                return true;
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName || window.$t('mis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                } else if (window.$t('mis.accountReward.applyProposal') == clickName) {
                    //校验
                    if(!this.judge()){
                        return;
                    }
                    this.dataChanage(URL.rebateActivity.applyProposal, {ids: this.ids}, res => {
                        if (res.code == 0) {
                            this.$message.success(window.$t('mis.accountReward.applySuccess'));
                            this.$refs.childTable.defaultGetData(this.queryData);
                        } else {
                            this.$message.error(window.$t('mis.accountReward.applyFail'));
                        }
                    });
                } else if (window.$t('mis.accountReward.cancelProposal') == clickName) {
                    //校验
                    if(!this.judge()){
                        return;
                    }
                    this.dataChanage(URL.rebateActivity.cancelProposal, {ids: this.ids}, res => {
                        if (res.code == 0) {
                            this.$message.success(window.$t('mis.accountReward.applySuccess'));
                            this.$refs.childTable.defaultGetData(this.queryData);
                        } else {
                            this.$message.error(window.$t('mis.accountReward.applyFail'));
                        }
                    });
                } else if (window.$t('mis.bt.down') == clickName) {
                    download.exportExcel(URL.rebateActivity.downloadProActivity, data, window.$t('mis.accountReward.downloadProActivity'));
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model) {
                //根据是否包含id更新还是添加
                this.dataChanage(URL.rebateActivity.save, model, res => {
                    if (res.data.code == 0) {
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    } else {

                    }
                })
            },
            dataChanage(url, option, suc, fail) {
                this.axios.post(url, Qs.stringify(option || {})).then(res => {

                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data() {
            return {
                ids: "",
                proposals: "",
                addOrUpdateVisible: false,   // 新增／更新，弹窗visible状态
                queryData: {},
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [
                        {title: window.$t('mis.common.startTime'), field: 'beginDate', type: 5, format: 'yyyy-MM-dd HH:mm:ss'},
                        {title: window.$t('mis.common.endTime'), field: 'endDate', type: 5, format: 'yyyy-MM-dd HH:mm:ss'},
                        {title: window.$t('mis.accountReward.activeName'), field: 'activeName'},
                        {title: window.$t('mis.accountReward.proposalType'), field: 'proposalType', type: 2, optionList: proposalType, isNumber: true},
                        {title: window.$t('mis.accountReward.proposalStatus'), field: 'proposalStatus', type: 2, optionList: proposalStatus, isNumber: true},
                        {title: window.$t('mis.accountReward.activeType'), field: 'activeType', data: 0, hidden: true},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.bt.down')},
                        {click: window.$t('mis.accountReward.applyProposal')},
                        {click: window.$t('mis.accountReward.cancelProposal')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.rebateActivity.proposalList, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: window.$t('mis.accountReward.proposalNo'), field: 'proposalNo',h5Click: "details"},
                        {
                            title: window.$t('mis.accountReward.proposalType'), field: 'proposalType', render: (data, full) => {
                                return proposalType[data] || "";
                            }
                        },
                        {title: window.$t('mis.accountReward.activeId'), field: 'activeId'},
                        {title: window.$t('mis.accountReward.activeName'), field: 'activeName'},
                        {
                            title: window.$t('mis.accountReward.proposalStatus'), field: 'proposalStatus', render: (data, full) => {
                                return proposalStatus[data] || "";
                            }
                        },
                        {title: window.$t('mis.accountReward.beginDate'), field: 'beginDate'},
                        {title: window.$t('mis.accountReward.endDate'), field: 'endDate'},
                        {title: window.$t('mis.accountReward.expDay'), field: 'expDay'},
                        {title: window.$t('mis.accountReward.proposalUser'), field: 'proposalUser'},
                        {title: window.$t('mis.accountReward.proposalDate'), field: 'proposalDate'},
                        {title: window.$t('mis.accountReward.approvalUser'), field: 'approvalUser'},
                        {title: window.$t('mis.accountReward.approvalDate'), field: 'approvalDate'},
                    ]
                }
            }
        }
    }
</script>
